import hotelWifiAxios from '@shared/api/hotel-wifi-axios-instance';
import type { HotelWifiOrganizationConfig } from '@models/hotel-wifi/hotel-wifi.models';
import type {
  MikroTikRouterBody,
  OmadaRouterBody
} from '@modules/hotel-wifi-settings/models/router.model.ts';

const TEST_CONNECTION_TIMEOUT_MS = 15000;

export async function getHotelWifiOrganizationConfig(): Promise<HotelWifiOrganizationConfig> {
  const { data } = await hotelWifiAxios.get<HotelWifiOrganizationConfig>(
    '/organization-config'
  );
  return data;
}

export async function updateHotelWifiOrganizationConfig(
  body: Partial<HotelWifiOrganizationConfig>
): Promise<HotelWifiOrganizationConfig> {
  const { data } = await hotelWifiAxios.put<HotelWifiOrganizationConfig>(
    '/organization-config',
    body
  );
  return data;
}

export async function updateMikrotikRouterConfig(
  body: MikroTikRouterBody
): Promise<HotelWifiOrganizationConfig> {
  const { data } = await hotelWifiAxios.put<HotelWifiOrganizationConfig>(
    '/organization-config/router/mikrotik',
    body
  );
  return data;
}

export async function testMikrotikConnection(
  body: MikroTikRouterBody
): Promise<unknown> {
  const { data } = await hotelWifiAxios.post(
    '/organization-config/router/mikrotik/test-connection',
    body,
    { timeout: TEST_CONNECTION_TIMEOUT_MS }
  );
  return data;
}

export async function updateOmadaRouterConfig(
  body: OmadaRouterBody
): Promise<HotelWifiOrganizationConfig> {
  const { data } = await hotelWifiAxios.put<HotelWifiOrganizationConfig>(
    '/organization-config/router/omada',
    body
  );
  return data;
}

export async function testOmadaConnection(
  body: OmadaRouterBody
): Promise<unknown> {
  const { data } = await hotelWifiAxios.post(
    '/organization-config/router/omada/test-connection',
    body,
    { timeout: TEST_CONNECTION_TIMEOUT_MS }
  );
  return data;
}
